// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2069) return "static/chunks/2069.ee54b32c60fe3fee.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1146":"5bb2955bfffef7c7","2013":"54849f4e437a02cf","2983":"00edd5ee569114bc","4466":"af3bc4a3730be7e9","7988":"5b8b7e26929f2e96","9272":"389313dc760a9604"}[chunkId] + ".js";
};